import React from "react";
import env from "../env/env.json";

const TransmissionCU = () => {
  const email = env.email_ville;

  const redirectToHome = () => {
    const environnement = env.environnement;
    window.location.href = env[environnement].homepage;
  };

  return (
    <div className="container">
      <div className="row d-flex flex-column justify-content-center align-items-center">
        <h1 className="text-center">Votre dossier a bien été transmis</h1>
        <p className="text-center text-success p-4">
          <i className="far fa-check-circle fa-6x"></i>
        </p>
        <div>
          <p className="text-center">
            Votre demande a bien été envoyée.
            <br />
            Vous allez recevoir une copie de votre demande et le numéro de dépôt
            attribué à votre dossier par e-mail à l'adresse indiquée dans le
            formulaire
          </p>
          <p className="text-center">
            Si vous avez déposé cette demande en tant que mandataire, le
            demandeur en recevra également une copie à son adresse e-mail que
            vous avez renseigné dans le formulaire.
          </p>
          <p className="text-center">
            N'oubliez pas de vérifier dans le dossier "spams / courrier
            indésirable".
            <br />
            Si vous n'avez pas reçu la confirmation de dépôt, veuillez nous
            envoyer un message à{" "}
            <strong>
              <a href={"mailto:" + email} target="_blank" rel="noreferrer">
                {email}
              </a>
            </strong>
          </p>
        </div>
        <div className="col-12 d-flex justify-content-center p-4">
          <button
            type="button"
            className="btn btn-warning btn-md"
            onClick={redirectToHome}
          >
            Retour à la page d'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransmissionCU;
